import React from "react"
import tw, { styled } from "twin.macro"

const Main = ({ children, ...props }) => (
  <Style className="main" role="main" {...props}>
    {children}
  </Style>
)
export default Main

const Style = styled.div`
  ${tw`relative z-1`}

  ${({ tint }) =>
    tint ? `--layout-tint: var(--nova-${tint}, var(--nova-primary))` : ""};

  > .promotion {
    &:last-child {
      margin-bottom: 100px;
      margin-bottom: 13.5vmin;
    }
  }

  > * + .promotion {
    margin-top: 100px;
    margin-top: 13.5vmin;
  }
`
